import { observer } from "mobx-react-lite";
import { ArrowLeft, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { useDelayedFlag, useTran } from "@/hooks";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";

import { useFrameworkData, useKpiTargetsStore } from "../hooks";
import TargetSummaryTable from "../components/TargetSummaryTable";
import TargetSummarySkeleton from "../components/skeleton/TargetSummarySkeleton";
import { useEffect } from "react";

const TargetSummaryPage = observer(() => {
  const { t } = useTran();
  const navigate = useNavigate();
  const { loadingFrameworks } = useFrameworkData();
  const { getTargetSettingById, loadingDisclosures, loadingTargets } =
    useKpiTargetsStore();
  const location = useLocation();
  const { targetId } = useParams();

  const isLoading = loadingFrameworks || loadingDisclosures || loadingTargets;
  const showSkeleton = useDelayedFlag(isLoading);

  useEffect(() => {
    if (!targetId) return;
    getTargetSettingById(targetId);
  }, [targetId, getTargetSettingById]);

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("Target Summary")}
        description={t("Review saved targets for the selected filters.")}
        icon={FileText}
        actions={
          <Button
            variant="outline"
            onClick={() => {
              if (location.state?.from) {
                navigate(location.state.from);
              } else {
                navigate(-1);
              }
            }}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {t("Back")}
          </Button>
        }
      />

      {/* <div className="flex flex-wrap gap-2">
        <Badge variant="outline">
          {t("Framework")}: {selectedFramework}
        </Badge>
        <Badge variant="outline">
          {t("Category")}: {activeCategory}
        </Badge>
        <Badge variant="outline">
          {t("Year")}: {selectedYear}
        </Badge>
        {searchLabel ? (
          <Badge variant="secondary">
            {t("Search")}: {searchLabel}
          </Badge>
        ) : null}
      </div> */}

      {showSkeleton ? <TargetSummarySkeleton /> : <TargetSummaryTable />}
    </div>
  );
});

export default TargetSummaryPage;
